// extracted by mini-css-extract-plugin
export var container = "styles-module--container--7b5eb";
export var input = "styles-module--input--5fbbb";
export var searchArea = "styles-module--searchArea--2bce4";